import { TrainingSessionBuilder } from './training-session.builder';
import { UserNodeBuilder } from './user-node.builder';
import { TeamBuilder } from './team.builder';
import { Site } from './../site';
import { UserNode } from '../user-node';

export class SiteBuilder {
    static build(siteVO, isPrincipal): Site {
        const site = new Site();
        site.id = siteVO.id;
        site.nom = siteVO.nom;
        site.villeLabel = siteVO.villeLabel;
        site.villeCode = siteVO.villeCode;
        site.teams = [];
        site.sitelinkedusers = [];
        site.sessions = [];
        if (siteVO.teams) {
            siteVO.teams.forEach(teamVO => {
                site.teams.push(TeamBuilder.build(site.id, teamVO, isPrincipal));
            });
        }
        if (siteVO.sitelinkedusers) {
            siteVO.sitelinkedusers.forEach(userNodeVO => {
                site.sitelinkedusers.push(UserNodeBuilder.build(site.id, null, userNodeVO));
            });
        }
        if (siteVO.sessions && siteVO.sessions.length > 0) {
            site.id = siteVO.idSite;
            siteVO.sessions.forEach(trainingSessionVO => {
                site.sessions.push(TrainingSessionBuilder.build(site.id, trainingSessionVO));
            });
        }
        return site;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/builder/site.builder.ts